import { FC } from "react";
import { Asset } from "rujira.js";
import { i18n, Warning } from "rujira.ui";
import exclamation from "rujira.ui/src/assets/images/exclamation.gif";
import { Info } from "rujira.ui/src/components/icons/Icons";
import { LiquidationPrice, LtvLabel } from "./Health";
import { CdpSingle } from "./utils";

export const AdjustmentSummary: FC<{
  p: CdpSingle<Asset>;
}> = ({ p }) => {
  if (p.debt.amount === 0n && p.collateral.amount === 0n)
    return (
      <Warning
        className="warning--sm mt-2 condensed flex ai-c mx-a"
        color="orange">
        <img
          src={exclamation}
          alt=""
          className="filter-orange block no-shrink"
          style={{ width: "2rem", height: "2rem" }}
        />
        <div className="text-left fs-14 mr-1">Position Closed</div>
      </Warning>
    );
  if (p.collateral.amount === 0n)
    return (
      <Warning
        className="warning--sm mt-2 condensed flex ai-c mx-a"
        color="orange">
        <img
          src={exclamation}
          alt=""
          className="filter-orange block no-shrink"
          style={{ width: "2rem", height: "2rem" }}
        />
        <div className="text-left fs-14 mr-1">Invalid. Debt remaining.</div>
      </Warning>
    );

  return (
    <div className="col-12 col-md-8 offset-md-2">
      <div className="row wrap pad-mini mt-1.5 condensed fs-14">
        <div className="col-12 col-xs-4 text-center text-xs-left color-grey fw-500 py-0.5">
          <div
            data-tooltip-id="modal-tip"
            data-tooltip-html="Ratio of the Debt Value to the Adjusted Collateral Value"
            className="iflex ai-c no-select">
            {i18n.t("New LTV")}
            <Info className="ml-0.5 block w-2" />
          </div>
        </div>
        <div className="col-12 col-xs-8 text-center text-xs-right">
          <LtvLabel ltv={p.ltv} />
        </div>
        <div className="col-12 col-xs-4 text-center text-xs-left color-grey fw-500 py-0.5">
          {i18n.t("New Liquidation Price")}
        </div>
        <div className="col-12 col-xs-8 text-center text-xs-right">
          <LiquidationPrice p={p} />
        </div>
      </div>
    </div>
  );
};
